import type { Dispatch } from 'redux';

import { config } from '../config';
import { fetchData } from '../configuration/setup/fetch';
import type { RootState } from '../configuration/setup/store';
import { getAccessToken } from '../configuration/tokenHandling/tokenSlice';
import { actions } from './actions';
import { FETCH_POI_TAG, poiApi } from './poiApi';

export const fetchPoi = async (dispatch: Dispatch, getState: () => RootState) => {
    try {
        const url = `${config.backend.LIVEMONITOR_SERVICE}/pois`;
        const result = await fetchData(url, getAccessToken(getState()));

        const pois = {
            workshopPois: result.workshop_pois || [],
            customerPois: result.customer_pois || [],
        };

        dispatch(actions.fetchPoisSuccess(pois));
        dispatch(poiApi.util.invalidateTags([FETCH_POI_TAG]));
    } catch (error: unknown) {
        dispatch(actions.fetchPoisFailed(error as Error));
    }
};
